import { render, staticRenderFns } from "./EditRatesModal.vue?vue&type=template&id=154ae308&scoped=true"
import script from "./editRatesModal.ts?vue&type=script&lang=ts&external"
export * from "./editRatesModal.ts?vue&type=script&lang=ts&external"
import style0 from "./EditRatesModal.vue?vue&type=style&index=0&id=154ae308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ae308",
  null
  
)

export default component.exports